export default "__VITE_ASSET__B6avET4m__"